import { useTranslation } from 'react-i18next';
import {
  Flex,
  Icon,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@kognitos/lattice';

import { TriggerType } from '../TriggerTypeSelector/TriggerType';

export interface IScheduleTriggerOptionProps {
  /** Message explaining why the option is unavailable; enabled when undefined. */
  disabledReason?: string;
  onSelect: () => void;
}

/**
 * Schedule entry in the add-trigger picker. A disabled button swallows pointer
 * events, so the tooltip has to be anchored on a wrapper instead.
 */
export function ScheduleTriggerOption({
  disabledReason,
  onSelect,
}: IScheduleTriggerOptionProps) {
  const { t } = useTranslation('automation-inputs');

  const option = (
    <TriggerType
      icon={<Icon type="Calendar" size="md" />}
      title={t('triggerTypes.schedule.title')}
      description={t('triggerTypes.schedule.description')}
      onClick={onSelect}
      disabled={Boolean(disabledReason)}
      presentation="list"
    />
  );

  if (!disabledReason) {
    return option;
  }

  return (
    <Tooltip variant="primary">
      <TooltipTrigger asChild>
        <Flex width="full" data-testid="add-schedule-disabled-tooltip-trigger">
          {option}
        </Flex>
      </TooltipTrigger>
      <TooltipContent side="bottom" className="max-w-sm">
        {disabledReason}
      </TooltipContent>
    </Tooltip>
  );
}
